import _ from 'lodash';

const getTemplateContents = (template) =>
  _.chain(template.steps).map('contents').flatten().value();

export default getTemplateContents;
